<template>
  <div class="workshop cardover">
    <div class="workshop__author-pic">
      <img :src="info.img" />
    </div>
    <div class="workshop__info">
      <div class="flex">
        <p class="workshop__info-date">{{ info.level }}</p>
        <p class="workshop__info-date company_text">{{ info.company }}</p>
      </div>
      <h3 class="workshop__info-title">{{ info.title }}</h3>
      <p class="workshop__info-speaker">
        {{ info.salary }}
      </p>
    </div>
    <div class="workshop__action">
      <!-- <div class="workshop__action-info">
        <span>{{ workshop.fee === 0? 'Free':`Tk.${workshop.fee}` }}</span>
        <span>{{ getTimeLeft(workshop.workshop_ts) }}</span>
      </div> -->
      <router-link :to="info.link">
        <a class="btn ">Learn More</a>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ['info'],
}
</script>
<style scoped>
.company_text {
  color: #444446;
  font-weight: 700;
}
.workshop__info-date,
.workshop__info-title,
.workshop__info-speaker,
.btn {
  font-family: 'Manrope';
}

.workshop__info-speaker {
  color: #f9a203;
}
img {
  aspect-ratio: 16/9;
  object-fit: cover;
}
.btn {
  min-width: 100%;
  border: 1px solid #2465f3;
  color: #2465f3;
}

.workshop__action {
  display: flex;
  flex-grow: 1;

  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
}
.workshop__action a {
  min-width: 100%;
  color: #2465f3;
  font: 700 1rem/1.2rem 'Manrope';
}
@media only screen and (max-width: 600px) {
  .cardover {
    max-width: 335px;
  }
}
</style>
